<template>
  <div class="form">
    <form method="POST" @submit.prevent class="login-form">
      <input type="text" name="email" v-model="username" required />
      <label alt="Email Address" placeholder="Email Address"></label>

      <div class="pw-wrap">
        <input
          :type="showPassword ? 'text' : 'password'"
          v-model="password"
          name="password"
          required
        />
        <!-- After the label on purpose: the floating label is styled with
             `input + label`, so anything in between would break it. -->
        <label alt="Password" placeholder="Password"></label>
        <button
          type="button"
          class="pw-toggle"
          :aria-label="showPassword ? 'Hide password' : 'Show password'"
          :title="showPassword ? 'Hide password' : 'Show password'"
          @click="showPassword = !showPassword"
        >
          <span class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>

      <div class="forget-password">
         <router-link to="/forgetpassword">Forgot Password ?</router-link>
      </div>

      <div class="next-button">
        <button class="sign" type="link">
          <router-link :to="{name: 'UserRegister'}">Sign Up</router-link>
        </button>
        <button
          class="btn-amej-button"
          type="submit"
          @click="processLogin"
          variant="amej-button"
        >Login</button>
      </div>
    </form>

    <b-modal
      ref="loader_modal"
      id="loader_modal"
      class="loader_modal"
      size="sm"
      text-center
      headerClass="border-bottom-0"
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="text-center p-4">
        <b-spinner variant="light" label="Text Centered"></b-spinner>
      </div>
    </b-modal>

    <b-toast id="error-toast" variant="danger" solid append-toast toaster="b-toaster-top-center">
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Error!!!</strong>
      </div>
      <div class="text-danger" v-for="(error,index) in errors.auth" :key="index">{{ error }}</div>
    </b-toast>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { saveSession, dashboardRouteName } from "../../utils/auth";
const axios = require("axios");
export default {
  name: "InputField",
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      text: "Login Form",
      available: false,
      show: false,
      errors: { auth: [] },
      disabledLogin: true,
    };
  },
  computed: {
    ...mapState(["token"]),
  },
  created() {
    var token = window.localStorage.getItem("token");
    if (token != undefined && token != "") {
      this.$router.replace("/app");
    }
  },
  methods: {
    ...mapMutations(["setToken"]),
    formshow() {
      (this.show = !this.show), (this.available = !this.available);
    },
    processLogin() {
      var formData = {
        email: this.$data.username,
        password: this.$data.password,
      };

      this.$refs["loader_modal"].show();

      axios
        .post("checkuser", { email: this.$data.username })
        .then((response) => {          
          if (response.data.status === "true" || response.data.status === true) {
            
            axios
              .post("auth/login", formData)
              .then((authResponse) => {
                console.log('Response: ', authResponse.data);
                
                // Store the WHOLE session: access, refresh and role.
                // The refresh token was previously discarded, which is why the session
                // could never be renewed - one expired access token ended it.
                const accessToken = saveSession(authResponse.data);

                if (accessToken) {
                  this.setToken(accessToken);
                  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
                }

                // 3. Hide loader modal on success!
                this.$refs["loader_modal"].hide();

                // 4. Uncommented & clean routing structure
                // Honour ?next= so a user bounced off a protected page lands back on it.
                const next = this.$route.query.next;
                if (next) {
                  this.$router.replace(decodeURIComponent(next)).catch(function () {});
                } else {
                  this.$router.replace({ name: dashboardRouteName() }).catch(function () {});
                }
              })
              .catch((error) => {
                this.$refs["loader_modal"].hide();
                if (error.response && error.response.data) {
                  this.errors["auth"] = [error.response.data.message || "Authentication failed."];
                  this.$bvToast.show("error-toast");
                }
                this.errored = true;
              });

          } else {
            // Handle case where checkuser returns status "false"
            this.$refs["loader_modal"].hide();
            this.errors["auth"] = ["User verification failed."];
            this.$bvToast.show("error-toast");
          }
        })
        .catch((error) => {
          this.$refs["loader_modal"].hide();
          if (error.response) {
            if (error.response.status == 401) {
              this.errors["auth"] = ["Admin cannot login."];
            } else if (error.response.status == 400) {
              this.errors["auth"] = ["Invalid username/password."];
            } else {
              this.errors["auth"] = ["An unexpected error occurred."];
            }
            this.$bvToast.show("error-toast");
          }
          this.errored = true;
        });
    },
    // processLoginOld() {
    //   var formData = {
    //     email: this.$data.username,
    //     password: this.$data.password,
    //   };
    //   this.$refs["loader_modal"].show();
    //   axios
    //     .post("checkuser", {
    //       email: this.$data.username,
    //     })
    //     .then((response) => {          
    //       if (response.data.status == "true") {
    //         axios
    //           // .post("token/obtain", formData)
    //           .post("auth/login", formData)
    //           .then((response) => {
    //             console.log('Responce: ', response.data);
    //             window.localStorage.setItem("token", response.data.tokens.access);
    //             this.setToken(response.data.access);
    //             axios.defaults.headers.common["authorization"] = "Bearer " + window.localStorage.getItem("token");
                
    //             let userismerchant = response.data.merchant_status;
    //             // if(userismerchant === "yes"){
    //             //   this.$router.replace("/merchant-dashboard");
    //             // }else{
    //             //   this.$router.replace("/app");
    //             // }
    //           })
    //           .catch((error) => {
    //             this.$refs["loader_modal"].hide();
    //             if (error.response) {
    //               this.errors["auth"] = [error.response.data.message];
    //               this.$bvToast.show("error-toast");
    //             }
    //             this.errored = true;
    //           });
    //       }
    //     })
    //     .catch((error) => {
    //       this.$refs["loader_modal"].hide();
    //       if (error.response.status == 401) {
    //         this.errors["auth"] = ["Admin cannot login."];
    //         this.$bvToast.show("error-toast");
    //       } else if (error.response.status == 400) {
    //         this.errors["auth"] = ["Invalid username/password."];
    //         this.$bvToast.show("error-toast");
    //       }
    //       this.errored = true;
    //     });
    // },
  },
};
</script>
<style lang="scss" scoped>
  @import '../../css/style.scss';
</style>